import script from "./MasterDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MasterDashboard.vue?vue&type=script&setup=true&lang=js"

import "./MasterDashboard.vue?vue&type=style&index=0&id=7609b818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7609b818"]])

export default __exports__